module.exports = __webpack_public_path__ + "site/img/index2en1.4c2a8b9d.png";